// based on vc-align 2.4.5
import Align from './Align';
export default Align;
